// UNIVERSAL 5.0 — 49 tools in 4 blocks: the U3 contour with U4 internals, trimmed to what is actually
// engraved on this card (no KIT tools in this SKU). The hatchet is fully sharpened, with a sharp knife
// and a serrated blade as positions of their own.
// Positions are card millimetres (mx from the face's left edge, my from its top); est:true = a parked
// guess on a placement grid. Numbering 1–49 → marks live in the u5_marks_v5 store (see MSTORE in the hub).
window.U5 = {
 "card": {
  "w": 85.4,
  "h": 55.4,
  "t": 2.4
 },
 "hom": {
  "A": [[0.011381, 0.002173, -0.16384], [-0.003915, 0.013691, -0.035084], [0.000424, -0.000885, 1]],
  "B": [[0.012151, -0.004959, 0.153754], [0.009279, 0.015502, -0.665184], [0.000781, 0.000248, 1]]
 },
 "blocks": [
  {
   "id": "cut",
   "label": "Cut, pry & open",
   "sub": "Blades, saw, levers, openers",
   "tools": [
    {
     "cat": "CLEAN",
     "side": "A",
     "mx": 0,
     "my": 45.4,
     "name": "Wide BBQ grill scraper",
     "desc": "Broad scraping edge for grill bars and baked-on residue.",
     "sc": "Cleaning a rental grill before the coals go in.",
     "n": 13,
     "est": false
    },
    {
     "cat": "DRIVE",
     "side": "A",
     "mx": 0.9,
     "my": 55.4,
     "name": "Flat screwdriver",
     "desc": "Standard flat tip on the card body.",
     "sc": "A battery hatch screw on a travel scale.",
     "n": 14,
     "est": false
    },
    {
     "cat": "OPEN",
     "side": "A",
     "mx": 10.8,
     "my": 54.2,
     "name": "Can opener",
     "desc": "Hooked lever that walks around a can lid.",
     "sc": "Tinned food in a cabin with no opener in the drawer.",
     "n": 15,
     "est": false
    },
    {
     "cat": "CUT",
     "side": "A",
     "mx": 19.8,
     "my": 49.2,
     "name": "Cord cutter",
     "desc": "Protected notch that shears cord and zip ties without an exposed edge.",
     "sc": "Cutting a zip tie off luggage at the airport.",
     "n": 16,
     "est": false
    },
    {
     "cat": "DRIVE",
     "side": "A",
     "mx": 81,
     "my": 0,
     "name": "Flat screwdriver",
     "desc": "Second, narrower flat tip on the opposite edge.",
     "sc": "Small terminal screws on a plug.",
     "n": 17,
     "est": false
    },
    {
     "cat": "PRY",
     "side": "A",
     "mx": 85.4,
     "my": 3.4,
     "name": "Nail puller",
     "desc": "V-notch that grips a nail head for pulling.",
     "sc": "Pulling a proud nail out of a pallet.",
     "n": 18,
     "est": false
    },
    {
     "cat": "PRY",
     "side": "A",
     "mx": 85.4,
     "my": 8.1,
     "name": "Pry bar",
     "desc": "Thick lever end for lids, staples and stuck panels.",
     "sc": "Levering a paint lid open at the site.",
     "n": 19,
     "est": false
    },
    {
     "cat": "CLEAN",
     "side": "A",
     "mx": 85.4,
     "my": 24.9,
     "name": "Scraper",
     "desc": "Flat broad edge for paint, ice and hide.",
     "sc": "Scraping frost off a windscreen.",
     "n": 20,
     "est": false
    },
    {
     "cat": "DIG",
     "side": "A",
     "mx": 85.4,
     "my": 30.3,
     "name": "Shovel",
     "desc": "Scoop profile — lash it to a stick to dig.",
     "sc": "Digging a trench around the tent in rain.",
     "n": 21,
     "est": false
    },
    {
     "cat": "CHOP",
     "side": "A",
     "mx": 85.4,
     "my": 36,
     "name": "Sharp hatchet",
     "desc": "Fully sharpened hatchet edge — lash it to a stick and it chops, or use it in hand to split and carve.",
     "sc": "Splitting kindling and shaving a stake at camp.",
     "n": 22,
     "est": false
    },
    {
     "cat": "OPEN",
     "side": "A",
     "mx": 83.5,
     "my": 55.4,
     "name": "Box opener",
     "desc": "Shielded hook that slits tape without touching the contents.",
     "sc": "Opening a parcel without slicing the goods inside.",
     "n": 23,
     "est": false
    },
    {
     "cat": "OPEN",
     "side": "B",
     "mx": 67.7,
     "my": 51.4,
     "name": "Bottle opener",
     "desc": "Lever notch for crown caps.",
     "sc": "A bottle at a picnic with no opener.",
     "n": 24,
     "est": false
    },
    {
     "cat": "FIRE",
     "side": "A",
     "mx": 41.5,
     "my": 55.4,
     "name": "Firestarter",
     "desc": "Hardened scraper spots that throw sparks off a ferro rod.",
     "sc": "Lighter soaked in a river crossing; the ferro rod still works.",
     "n": 25,
     "est": false
    },
    {
     "cat": "CUT",
     "side": "A",
     "mx": 85.4,
     "my": 42.6,
     "name": "Sharp knife",
     "desc": "A straight sharpened edge of its own, fine enough for clean cuts the hatchet is too heavy for.",
     "sc": "Slicing rope, food or packaging without swapping tools.",
     "n": 26,
     "est": false
    },
    {
     "cat": "CUT",
     "side": "A",
     "mx": 72.7,
     "my": 55.4,
     "name": "Serrated blade",
     "desc": "A separate toothed section that saws through rope, webbing and seatbelt where a plain edge would slip.",
     "sc": "Cutting a jammed seatbelt or a loaded strap in one pull.",
     "n": 27,
     "est": false
    }
   ]
  },
  {
   "id": "wrench",
   "label": "Wrench & drive",
   "sub": "Nuts, bolts, valves, bits",
   "tools": [
    {
     "cat": "WRENCH",
     "side": "A",
     "mx": 31,
     "my": 10.9,
     "name": "Wrenches 5/16\", 3/8\", 1/2\"",
     "desc": "Imperial run, with the 1/2\" as a closed wrench rather than an open jaw — it grips a rounded nut that an open jaw would slip off.",
     "sc": "A rounded 1/2\" nut on a trailer hitch that no open spanner will hold.",
     "n": 1,
     "est": false
    },
    {
     "cat": "WRENCH",
     "side": "A",
     "mx": 46.2,
     "my": 12.1,
     "name": "Wrenches 9, 10, 11, 12 mm",
     "desc": "The metric sizes you actually meet on bikes, drones and flat-pack furniture.",
     "sc": "Loose M6 on a rack in a car park.",
     "n": 2,
     "est": false
    },
    {
     "cat": "WRENCH",
     "side": "A",
     "mx": 28.7,
     "my": 26,
     "name": "Wrenches 9/16\", 10/16\", 13 mm, 15 mm",
     "desc": "The larger run — imperial and metric side by side.",
     "sc": "A 13 mm bolt on a bike rack, no toolbox in the boot.",
     "n": 3,
     "est": false
    },
    {
     "cat": "WRENCH",
     "side": "B",
     "mx": 38.7,
     "my": 11.7,
     "name": "Butterfly wrench",
     "desc": "Wing-nut cutout for butterfly and thumb nuts.",
     "sc": "Tightening a butterfly nut on a bike seat post.",
     "n": 4,
     "est": false
    },
    {
     "cat": "WRENCH",
     "side": "A",
     "mx": 67.4,
     "my": 35.9,
     "name": "O₂ gas wrench",
     "desc": "Cutout for oxygen bottle fittings.",
     "sc": "Opening an O₂ regulator on a welding set.",
     "n": 5,
     "est": false
    },
    {
     "cat": "WRENCH",
     "side": "A",
     "mx": 70.7,
     "my": 39.4,
     "name": "Wrenches 6, 7 mm",
     "desc": "The small metric pair.",
     "sc": "A 6 mm nut on a drone arm.",
     "n": 6,
     "est": false
    },
    {
     "cat": "DRIVE",
     "side": "B",
     "mx": 67.6,
     "my": 9.5,
     "name": "1/4\" hex bit driver",
     "desc": "Holds standard 1/4\" hex bits.",
     "sc": "Driving a wood screw with a bit from the toolbox.",
     "n": 7,
     "est": false
    },
    {
     "cat": "DRIVE",
     "side": "B",
     "mx": 75.7,
     "my": 7.9,
     "name": "4 mm CRV bit driver",
     "desc": "Holds 4 mm CRV precision bits.",
     "sc": "Electronics screws on a laptop hatch.",
     "n": 8,
     "est": false
    },
    {
     "cat": "DRIVE",
     "side": "B",
     "mx": 75.7,
     "my": 14.1,
     "name": "Leatherman standard bit driver",
     "desc": "Takes the flat Leatherman-standard bits — 4 mm and 1/8\" — and locks them so they cannot wobble out under torque.",
     "sc": "Torquing a hinge screw with the card as the handle.",
     "n": 9,
     "est": false
    },
    {
     "cat": "WRENCH",
     "side": "B",
     "mx": 74.5,
     "my": 40.2,
     "name": "Wrenches 2.5, 3 mm, 3/16\", 5, 5.5 mm",
     "desc": "The fine run for small hardware.",
     "sc": "A 3 mm nut on a model chassis.",
     "n": 10,
     "est": false
    },
    {
     "cat": "WRENCH",
     "side": "B",
     "mx": 65.8,
     "my": 48.5,
     "name": "Wrenches 8 mm, 5/16\"",
     "desc": "Open jaws for the two common mid sizes.",
     "sc": "An 8 mm nut on a scooter mirror.",
     "n": 11,
     "est": false
    },
    {
     "cat": "DRIVE",
     "side": "A",
     "mx": 0,
     "my": 5.7,
     "name": "Phillips screwdriver",
     "desc": "New on 5.0: a Phillips tip machined into the corner of the card, so cross-head screws no longer need a bit.",
     "sc": "Battery cover on a smoke alarm at 2 a.m. — the corner is already the right shape.",
     "n": 12,
     "est": false
    }
   ]
  },
  {
   "id": "field",
   "label": "Field, navigate & KIT",
   "sub": "Sun, stars, wire, removable kits",
   "tools": [
    {
     "cat": "FIELD",
     "side": "B",
     "mx": 0,
     "my": 5.8,
     "name": "SOS signal",
     "desc": "Morse SOS reference engraved on the card.",
     "sc": "Signalling with a torch when the phone is dead.",
     "n": 40,
     "est": false
    },
    {
     "cat": "FIELD",
     "side": "B",
     "mx": 15.4,
     "my": 17.3,
     "name": "Wire bender holes",
     "desc": "A row of holes in different diameters — feed the wire in and bend it to a clean, repeatable angle.",
     "sc": "Bending a wire hook to hang a lamp in a tent.",
     "n": 41,
     "est": false
    },
    {
     "cat": "FIELD",
     "side": "B",
     "mx": 0,
     "my": 33.8,
     "name": "Plumb bob",
     "desc": "Hang the card on a cord and the edge gives you true vertical.",
     "sc": "Checking a fence post is upright with no level to hand.",
     "n": 42,
     "est": false
    },
    {
     "cat": "NAVIGATE",
     "side": "B",
     "mx": 4.4,
     "my": 51.5,
     "name": "Sundial clock",
     "desc": "Gnomon slot and hour lines — the sun gives you the time.",
     "sc": "Telling the time on a ridge with a flat battery.",
     "n": 43,
     "est": false
    },
    {
     "cat": "NAVIGATE",
     "side": "B",
     "mx": 7.9,
     "my": 10.7,
     "name": "Sundial compass",
     "desc": "The same dial read the other way round: the sun gives you north.",
     "sc": "Finding north at midday without a magnetic compass.",
     "n": 44,
     "est": false
    },
    {
     "cat": "FIELD",
     "side": "A",
     "mx": 27,
     "my": 55.4,
     "name": "Sharpening angle guide",
     "desc": "Reference angles for setting a blade against a stone.",
     "sc": "Getting the bevel angle right on a kitchen knife.",
     "n": 45,
     "est": false
    },
    {
     "cat": "FIELD",
     "side": "A",
     "mx": 33.2,
     "my": 55.4,
     "name": "Knife sharpener",
     "desc": "Carbide notch for a quick edge touch-up.",
     "sc": "Bringing a dulled blade back mid-trip.",
     "n": 46,
     "est": false
    },
    {
     "cat": "NAVIGATE",
     "side": "B",
     "mx": 42.3,
     "my": 30.2,
     "name": "Military distance ruler",
     "desc": "Mil-style ranging scale — reads distance by apparent size, no metric ticks involved.",
     "sc": "Estimating range to a ridge line on a map exercise.",
     "n": 47,
     "est": false
    },
    {
     "cat": "CUT",
     "side": "B",
     "mx": 48.5,
     "my": 41.5,
     "name": "Wire stripper",
     "desc": "Notch that strips insulation without nicking the core.",
     "sc": "Stripping a lamp cord for a new plug.",
     "n": 48,
     "est": false
    },
    {
     "cat": "MEASURE",
     "side": "B",
     "mx": 78.3,
     "my": 55.4,
     "name": "Tyre thread depth guide",
     "desc": "Stepped tabs that read tread depth in the legal range.",
     "sc": "Checking tread before a long drive.",
     "n": 49,
     "est": false
    }
   ]
  },
  {
   "id": "measure",
   "label": "Measure & draw",
   "sub": "Rulers, gauges, angles, circles",
   "tools": [
    {
     "cat": "MEASURE",
     "side": "A",
     "mx": 38.8,
     "my": 0,
     "name": "Inch ruler",
     "desc": "Full inch scale down the long edge, quarter-inch ticks.",
     "sc": "Checking a shelf gap in a hardware aisle.",
     "n": 28,
     "est": false
    },
    {
     "cat": "DRAW",
     "side": "B",
     "mx": 55.9,
     "my": 0,
     "name": "Quick angle 30° / 45° / 60°",
     "desc": "Three cut corners that give the common angles without a protractor.",
     "sc": "Marking a 45° mitre on trim with nothing but the card.",
     "n": 29,
     "est": false
    },
    {
     "cat": "MEASURE",
     "side": "A",
     "mx": 44.4,
     "my": 42.3,
     "name": "Inch drill guide",
     "desc": "Stepped holes for sizing imperial bits and screws.",
     "sc": "Matching a wood screw to the right bit on site.",
     "n": 30,
     "est": false
    },
    {
     "cat": "DRAW",
     "side": "B",
     "mx": 26.7,
     "my": 8.8,
     "name": "Circle template",
     "desc": "Graded holes for drawing circles and checking rod diameters.",
     "sc": "Marking a hole for a cable pass-through.",
     "n": 31,
     "est": false
    },
    {
     "cat": "DRAW",
     "side": "B",
     "mx": 0,
     "my": 20.6,
     "name": "Metric compass",
     "desc": "Pivot and scale for circles up to 100 mm diameter.",
     "sc": "Drawing a 80 mm circle on a repair patch.",
     "n": 32,
     "est": false
    },
    {
     "cat": "DRAW",
     "side": "B",
     "mx": 30.5,
     "my": 55.4,
     "name": "Inch compass",
     "desc": "Same pivot, imperial scale.",
     "sc": "Scribing a 3\" arc on a plywood offcut.",
     "n": 33,
     "est": false
    },
    {
     "cat": "DRAW",
     "side": "A",
     "mx": 61.5,
     "my": 28.7,
     "name": "Protractor",
     "desc": "Full angle scale around the arc.",
     "sc": "Setting a 30° angle on a workbench jig.",
     "n": 34,
     "est": false
    },
    {
     "cat": "MEASURE",
     "side": "A",
     "mx": 66.8,
     "my": 42.5,
     "name": "Sheet thickness gauge",
     "desc": "Stepped slots for gauging sheet metal and plastic.",
     "sc": "Checking sheet gauge before ordering a replacement panel.",
     "n": 35,
     "est": false
    },
    {
     "cat": "DRAW",
     "side": "A",
     "mx": 77.4,
     "my": 52.1,
     "name": "Parallel guide",
     "desc": "Notch run for stepping off parallel lines.",
     "sc": "Drawing a border 10 mm in from an edge.",
     "n": 36,
     "est": false
    },
    {
     "cat": "MEASURE",
     "side": "B",
     "mx": 41,
     "my": 0,
     "name": "Metric ruler",
     "desc": "Millimetre scale along the back edge.",
     "sc": "Measuring a bolt length in mm.",
     "n": 37,
     "est": false
    },
    {
     "cat": "MEASURE",
     "side": "B",
     "mx": 40.5,
     "my": 41.8,
     "name": "Metric drill guide",
     "desc": "Stepped holes for metric bits and rod.",
     "sc": "Sizing a metric bit for a wall plug.",
     "n": 38,
     "est": false
    },
    {
     "cat": "DRAW",
     "side": "B",
     "mx": 84.8,
     "my": 45.4,
     "name": "Precision protractor",
     "desc": "Fine-degree arc for accurate angle work.",
     "sc": "Transferring a 22° angle onto a workpiece.",
     "n": 39,
     "est": false
    }
   ]
  }
 ],
 "photo": {
  "A": "https://mrf.tools/cdn/shop/files/mrf26-u5-photo-a.jpg?v=b3",
  "B": "https://mrf.tools/cdn/shop/files/mrf26-u5-photo-b.jpg?v=b3"
 }
};
